import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const textru = {
  responseTextRuUniqueness: lazyModuleMethod(
    () => import('./responseTextRuUniqueness'),
    'default'
  ),
}
